<div class="risk-bar-graph">
  <div class="risk-bar-graph__graph-container"
    [ngClass]="{'risk-bar-graph__graph-container--expand-modal': isModal}">
  </div>
  <div class="common-tooltip-info__container-full"
    [id]="'risk-bar-graph-tooltip-'+idGraph">
    <div class="common-dropdown-list__info-items-title">
      <p class="common-dropdown-list__info-items-title-label"
        [afTranslate]="'field-items.dependencies'"></p>
      <button class="common-button__icon-xs-noborder"
        (click)="closeTooltip()">
        <i class="lf-icon-close-thick common-icon__sm"></i>
      </button>
    </div>
    <div class="risk-bar-graph__subheader-tooltip">
      <div class="common-badge__block-dot-md">
        <div class="common-badge__dot-md"
          [ngStyle]="{'background': riskBarGraph.nodeSelected.color}"></div>
      </div>
      <div class="risk-bar-graph__subheader-tooltip-text-block">
        <p class="risk-bar-graph__subheader-tooltip-text-bold">{{riskBarGraph.nodeSelected?.typeRisk}}:</p>
        <span-tooltip class="risk-bar-graph__subheader-tooltip-text"
          [text]="riskBarGraph.nodeSelected?.label"></span-tooltip>
      </div>
    </div>
    <ul class="common-tooltip-info__risk-list common-tooltip-info__risk-list--border-top">
      @for (risk of riskBarGraph.nodeSelected.dependencies; track $index) {
        <li class="common-tooltip-info__risk-special">
          <div class="common-tooltip-info__risk-item-special">
            <p class="common-tooltip-info__risk-item-special-text common-tooltip-info__risk-item-special-text--black">{{risk}}</p>
          </div>
        </li>
      }
    </ul>
  </div>
</div>
